export const CarTypeColumns = [
    {
        name: "Name",
        selector: (row) => row["Name"],
        sortable: true,
        center: true,

    },
    {
        name: "Seats",
        selector: (row) => row["Seats"],
        sortable: true,
        center: true,
    },
    {
        name: "Passengers",
        selector: (row) => row["Passengers"],
        sortable: true,
        center: true,

    },

    {
        name: "Bags",
        selector: (row) => row["Bags"],
        sortable: true,
        center: true,

    },
    {
        name: "IsDeleted",
        selector: (row) => row["IsDeleted"],
        sortable: true,
        center: true,

    },
    {
        name: "",
        cell: (row) => row["action"],
        sortable: true,
        center: true,
        width: "30px",
    },
    {
        name: "Deleted",
        selector: (row) => row["Deleted"],
        sortable: true,
        center: true,
        width:"0",
        omit:true,
    },
]